import { __decorate } from "tslib";
import { Directive, Renderer2, ElementRef, Input } from "@angular/core";
let HideElementDirective = class HideElementDirective {
    renderer;
    elmRef;
    divHide;
    constructor(renderer, elmRef) {
        this.renderer = renderer;
        this.elmRef = elmRef;
    }
    ngOnInit() {
        if (this.divHide)
            this.renderer.addClass(this.elmRef.nativeElement, "divHide");
        else
            this.renderer.removeClass(this.elmRef.nativeElement, "divHide");
    }
    static ctorParameters = () => [
        { type: Renderer2 },
        { type: ElementRef }
    ];
    static propDecorators = {
        divHide: [{ type: Input, args: ["divHide",] }]
    };
};
HideElementDirective = __decorate([
    Directive({
        standalone: false,
        selector: "[appHideElement]"
    })
], HideElementDirective);
export { HideElementDirective };
